module.exports = __webpack_public_path__ + "strengthen-white.svg?67a05d0bef328d40e31af2dcb27e7882";